import React from 'react';
import {useLocation, useNavigate, useParams, useSearchParams} from 'react-router-dom';
import {getComponentName} from '../helpers/getComponentName';
import {WithRouterApiProps} from '../@types/hocs/WithRouterApiProps';
import hoistStatics from 'hoist-non-react-statics';

export function withRouterApi<Props extends WithRouterApiProps = WithRouterApiProps>(
        WrappedComponent: React.ComponentType<Props>
) {
    const ComponentWrapper = (props: Omit<Props, keyof WithRouterApiProps>) => {
        return <WrappedComponent
                {...(props as Props)}
                urlLocation={useLocation()}
                urlNavigate={useNavigate()}
                urlParams={useParams()}
                urlSearchParams={useSearchParams()}
        />;
    };

    ComponentWrapper.displayName = `withUrlNavigation(${getComponentName(WrappedComponent)})`;

    return hoistStatics(ComponentWrapper, WrappedComponent);
}
